























































import ApiConfiguration from '@/classes/ApiConfiguration';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import { SavedSearchModel } from '@/services/GeneratedApi';
import { Search } from '@/types';
import Vue from 'vue';
import { Dictionary } from 'vue-router/types/router';
import LoadingSpinner from './LoadingSpinner.vue';
import MStoreSpinnerButton from './MStoreSpinnerButton.vue';

export default Vue.extend({
  props: {
    hideActions: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      isLoading: true,
      savedSearches: {} as Dictionary<SavedSearchModel[]>,
      isDeleteModalShowing: false,
      savedSearchToDelete: {},
      isSavedSearchDeleting: false,
      isRenameModalShowing: false,
      savedSearchToRename: {},
      isSavedSearchRenaming: false,
      newName: ''
    };
  },
  computed: {
    savedSearchesEntries(this: any) {
      const entries = Object.entries(this.savedSearches);
      if (!entries.length) {
        return [];
      }

      const privateSearchesIndex = entries.findIndex((x) => x[0] === 'My Searches');
      if (privateSearchesIndex) {
        entries.unshift(entries.splice(privateSearchesIndex, 1)[0]);
      }

      return entries;
    }
  },
  methods: {
    async getSavedSearches(this: any) {
      this.isLoading = true;
      const privateSearchesLabel = 'My Searches';
      try {
        const savedSearchesList = await ApiConfiguration.api().search.searchSavedSearchesList();
        this.savedSearches = savedSearchesList.reduce((savedSearches, savedSearch) => {
          if (!savedSearch.roleName) {
            return savedSearches[privateSearchesLabel]
              ? { ...savedSearches, [privateSearchesLabel]: [...savedSearches[privateSearchesLabel], savedSearch] }
              : { ...savedSearches, [privateSearchesLabel]: [savedSearch] };
          }

          return savedSearches[savedSearch.roleName!]
            ? { ...savedSearches, [savedSearch.roleName]: [...savedSearches[savedSearch.roleName], savedSearch] }
            : { ...savedSearches, [savedSearch.roleName]: [savedSearch] };
        }, {} as Dictionary<SavedSearchModel[]>) as Dictionary<SavedSearchModel[]>;
      } finally {
        this.isLoading = false;
      }
    },
    getSavedSearchHref(this: any, savedSearchId: number) {
      return this.isSubmitting ? 'javascript:;' : this.$router.resolve({ name: Search.Results.name, params: { savedSearchId } }).href;
    },
    async showRenameModal(this: any, savedSearch: SavedSearchModel) {
      this.savedSearchToRename = savedSearch;
      this.newName = savedSearch.name;
      this.isRenameModalShowing = true;
      await Vue.nextTick();
    },
    async renameSavedSearch(this: any) {
      this.isSavedSearchRenaming = true;
      const savedSearchToUpdate = { ...this.savedSearchToRename, name: this.newName };
      try {
        await ApiConfiguration.api().search.searchSavedSearchUpdate(savedSearchToUpdate);
        SnotifyConfiguration.showSuccess('Successfully Renamed Saved Search');
        await this.getSavedSearches();
      } finally {
        this.isRenameModalShowing = false;
        this.isSavedSearchRenaming = false;
      }
    },
    onRenameModalHidden(this: any) {
      this.savedSearchToRename = {};
      this.newName = '';
    },
    showDeleteModal(this: any, savedSearch: SavedSearchModel) {
      this.savedSearchToDelete = savedSearch;
      this.isDeleteModalShowing = true;
    },
    async deleteSavedSearch(this: any) {
      this.isSavedSearchDeleting = true;
      try {
        await ApiConfiguration.api().search.searchSavedSearchesDelete(this.savedSearchToDelete.id);
        SnotifyConfiguration.showSuccess('Successfully Deleted Saved Search');
        await this.getSavedSearches();
      } finally {
        this.isDeleteModalShowing = false;
        this.isSavedSearchDeleting = false;
      }
    }
  },
  async mounted(this: any) {
    await this.getSavedSearches();
  },
  components: {
    MStoreSpinnerButton,
    LoadingSpinner
  }
});
